// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"594":"about","757":"not-found"}[chunkId] + "." + {"594":"7a186936","757":"8b125544"}[chunkId] + ".js";
};